import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { debug } from '@/utils/debug';

export const useSupabaseFeatureFlags = () => {
  const [flags, setFlags] = useState<Record<string, boolean>>({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFeatureFlags();
  }, []);

  const loadFeatureFlags = async () => {
    try {
      const { data, error } = await supabase
        .from('feature_flags')
        .select('key, enabled');

      if (error) throw error;

      const flagMap = data.reduce((acc, flag) => {
        acc[flag.key] = flag.enabled;
        return acc;
      }, {} as Record<string, boolean>);

      setFlags(flagMap);
    } catch (error) {
      debug.error('Error loading feature flags:', error);
    } finally {
      setLoading(false);
    }
  };

  return { flags, loading, isFeatureEnabled: (key: string) => flags[key] || false };
};